import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'software-deployments.sidebar-content.configuration.icons.title',
		defaultMessage: 'Icons',
		description: 'The title of view configuration for icon visibilities in the timeline table',
	},
	showIconKey: {
		id: 'software-deployments.sidebar-content.configuration.icons.show-icon-key',
		defaultMessage: 'Deployment Key',
		description: 'Label for check box to toggle timeline table legend to show/hide it',
	},
	multipleDeploymentsIconLabel: {
		id: 'software-deployments.sidebar-content.configuration.icons.multiple-deployments-icon-label',
		defaultMessage: 'Multiple Deployments',
		description:
			'Label for check box to toggle multiple deployments icon. When this is off, it will only show a signle icon, while when on, it will show the number of the deployments',
	},
});
